import React, { useState } from "react";
import { Container, Form } from "reactstrap";
import { useFormik } from "formik";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useHistory, useParams } from "react-router-dom";
import ResultHandler from "../../../components/ResultHandler";
import { editCompany, getCompany } from "../../../api/companies";
import FormButtonHandler from "../../../components/FormButtonHandler";
import { useResponse } from "../../../hooks/useResponse";
import { useTranslation } from "react-i18next";
import { useGetInstence } from "../../../hooks/useGetInstence";
import { MASTER_FIELDS, MEDIA_FIELDS_REQUIRED } from "./CONSTANT";
import CompanyForm from "./CompanyForm";
import * as Yup from "yup";
import MasterForm from "./MasterForm";

function getValidationSchema(fields) {
  const FIELDS_VALIDATION = {};

  fields.forEach((f) => {
    if (f.type == "file-v2") {
      FIELDS_VALIDATION[f.key] = Yup.mixed();
      // .required("This Field Is Required");
    } else {
      FIELDS_VALIDATION[f.key] = Yup.string()
        .nullable()
        .required("This Field Is Required");
    }
  });

  return FIELDS_VALIDATION;
}

const EditCompany = () => {
  let navigate = useHistory();

  const { t } = useTranslation();

  const params = useParams();

  const [editedCompany, setEditedCompany] = useState(null);

  const { instenceLoading, instenceError, instenceSuccess } = useGetInstence(
    getCompany,
    params.id,
    (response) => {
      setEditedCompany(response.data.data.company);
    }
  );

  const { setData, loading, error, success } = useResponse(editCompany, () => {
    navigate.goBack();
  });

  // Form validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      ...editedCompany,
    },
    validationSchema: Yup.object(
      params.action == "all"
        ? getValidationSchema(MEDIA_FIELDS_REQUIRED)
        : getValidationSchema(MASTER_FIELDS)
    ),
    onSubmit: (values) => {
      let data = new FormData();
      Object.keys(values).map((key) => {
        if (values[key]) {
          data.append(key, values[key]);
        }
      });
      setData({ type: "edit", id: params.id, data });
    },
  });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={t("Companies")}
            breadcrumbItem={
              "Edit " + (params.action == "all" ? "Company" : "Company Master")
            }
          />
          {editedCompany && (
            <Form
              className="needs-validation"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              {params.action == "all" && (
                <CompanyForm validation={validation} />
              )}
              {params.action == "master" && (
                <MasterForm validation={validation} />
              )}

              <FormButtonHandler btnTxt="Edit" loading={loading} />
            </Form>
          )}
          <ResultHandler
            loading={instenceLoading}
            error={error}
            success={success}
            successMsg={"Updated Successfully!"}
          />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EditCompany;
